import React, { useCallback, useState } from "react";
import Preloader from "./components/Preloader";
import ScrollProgress from "./components/ScrollProgress";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

export default function App() {
  const [loading, setLoading] = useState(true);
  const onDone = useCallback(() => setLoading(false), []);

  return (
    <div className="selection:bg-paper selection:text-ink">
      {loading && <Preloader onDone={onDone} />}

      <ScrollProgress />
      <Nav />

      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <Contact />
      </main>

      <Footer />
      <FloatingWhatsApp />

      {/* One sheet of film grain over the whole page, to keep the flat
          black and white from looking synthetic. */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed -inset-1/2 z-[9998] animate-grain bg-grain opacity-[0.035]"
      />
    </div>
  );
}
